/**
 * ThemeApplier — web-only side effect that mirrors the resolved theme mode
 * onto <html data-theme> and the root `color-scheme`. The shared ThemeProvider
 * owns the state (and persistence); this is the DOM bridge the CSS in
 * tokens.css responds to. Rendered once, inside <ThemeProvider>.
 */
import { useEffect } from 'react';
import { useTheme } from '@wlb/shared/theme';

export function ThemeApplier(): null {
  const { mode, preferenceLoaded } = useTheme();

  useEffect(() => {
    // The inline script in index.html already applied the stored preference
    // before first paint. Until storage resolves, `mode` is only the OS
    // default, so writing it here would undo that and cause the very flash
    // the script prevents.
    if (!preferenceLoaded) return;
    const root = document.documentElement;
    root.setAttribute('data-theme', mode);
    root.style.colorScheme = mode;
  }, [mode, preferenceLoaded]);

  return null;
}
